import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigDsdAdresseService {
  constructor(private readonly translateService: TranslateService) {}
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getConfigAdresseBancaire(): any {
    const pcKey = environment.keyPosteCanada;
    return {
      search: {
        projectId: pcKey,
      },
      street: {
        slots: {
          hint: this.getTraduction('formulairePosteCanada.coordonneesBancaire.numeroEtRue.hint'),
        },
      },
      city: {
        slots: {
          hint: this.getTraduction('formulairePosteCanada.coordonneesBancaire.ville.hint'),
        },
      },
      pc: {
        slots: {
          hint: this.getTraduction('formulairePosteCanada.coordonneesBancaire.codePostal.hintAutrePays'),
        },
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention
      CA: {
        city: {
          slots: {
            hint: this.getTraduction('formulairePosteCanada.coordonneesBancaire.ville.hintCA'),
          },
        },
        pc: {
          slots: {
            hint: this.getTraduction('formulairePosteCanada.coordonneesBancaire.codePostal.hintCA'),
          },
        },
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention
      US: {
        pc: {
          slots: {
            hint: this.getTraduction('formulairePosteCanada.coordonneesBancaire.codePostal.hintUS'),
          },
        },
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention
      MX: {
        pc: {
          slots: {
            hint: this.getTraduction('formulairePosteCanada.coordonneesBancaire.codePostal.hintMX'),
          },
        },
      },
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getConfigAdresse(): any {
    const pcKey = environment.keyPosteCanada;
    return {
      search: {
        projectId: pcKey,
      },
      countries: ['CA'],
    };
  }

  private getTraduction(cleTraduction: string): string {
    let texteTraduction = '';
    this.translateService.get(cleTraduction).subscribe((texte: string) => (texteTraduction = texte));
    return texteTraduction;
  }
}
